import { HOVER_BACKGROUND, TEXT_COLOUR } from '@app/shared/primeng/config/primeng-constants';
import { MaterialBaseTokenSections } from '@primeuix/themes/material/base';

export const primeNgSemantic: MaterialBaseTokenSections.Semantic = {
	colorScheme: {
		light: {
			surface: {
				0: '#ffffff',
				50: '{neutral.50}',
				100: '{neutral.100}',
				200: '{neutral.200}',
				300: '{neutral.300}',
				400: '{neutral.400}',
				500: '{neutral.500}',
				600: '{neutral.600}',
				700: '{neutral.700}',
				800: '{neutral.800}',
				900: '{neutral.900}',
				950: '{neutral.950}'
			},
			text: {
				color: TEXT_COLOUR,
			},
			navigation: {
				item: {
					focusBackground: HOVER_BACKGROUND,
					activeBackground: HOVER_BACKGROUND
				}
			}
		}
	}
};